export { BaseScene } from './lib/scene';
